
export const formatDomain = (input: string) => {
  let domain = input.trim().toLowerCase();
  domain = domain.replace(/^(https?:\/\/)?(www\.)?/, '');
  domain = domain.replace(/\/$/, '');
  return domain;
};

export const getDomainFromUrl = (url: string): string | null => {
  try {
    const trimmedUrl = url.trim();
    if (!trimmedUrl) return null;

    // URL'yi parse et
    const urlObject = new URL(trimmedUrl.startsWith('http') ? trimmedUrl : `https://${trimmedUrl}`);
    
    // Hostname'i al ve formatla
    return formatDomain(urlObject.hostname);
  } catch (error) {
    return null;
  }
};
